import {
  FetchIndividualsResponse,
  Group,
  GroupMembership,
  GroupTreeNode,
} from '@aslanpay/portal-common-lib';
import { GroupWithPot } from 'app/hooks/useGroupsWithPot/types';

import { PrideEmployeeInformation } from './Prides.types';

function convertIndividualsToGroupMembers({
  allGroupMemberships,
  selectedGroup,
  individuals,
  selectedGroupMembers,
}: {
  allGroupMemberships: {
    group: GroupTreeNode;
    members: GroupMembership[];
  }[];
  selectedGroup: GroupWithPot | undefined;
  individuals: FetchIndividualsResponse | undefined;
  selectedGroupMembers: GroupMembership[];
}): PrideEmployeeInformation[] {
  const primaryGroupMap = new Map<string, GroupTreeNode>();

  allGroupMemberships.forEach(({ group, members }) => {
    members.forEach((membership) => {
      if (membership.isPrimaryGroup) {
        primaryGroupMap.set(membership.individualId, group);
      }
    });
  });

  const selectedGroupMemberIds = new Set(selectedGroupMembers.map((m) => m.individualId));

  return (individuals?.list ?? [])
    .map((individual) => {
      const primaryGroup = primaryGroupMap.get(individual.id);
      return {
        groupId: selectedGroup?.id ?? '',
        individualId: individual.id,
        individualName: `${individual.firstName} ${individual.lastName}`,
        individualEmail: individual.email,
        jobTitle: individual.jobTitle,
        membershipRole: 'MEMBER' as const,
        isPrimaryGroup: primaryGroup?.id === selectedGroup?.id,
        primaryGroup: primaryGroup as unknown as Group | undefined,
        isInSelectedGroup: selectedGroupMemberIds.has(individual.id),
      };
    })
    .sort((a, b) => {
      const aIn = selectedGroupMemberIds.has(a.individualId) ? 1 : 0;
      const bIn = selectedGroupMemberIds.has(b.individualId) ? 1 : 0;
      if (aIn !== bIn) return aIn - bIn;
      return a.individualName.localeCompare(b.individualName);
    });
}

export default convertIndividualsToGroupMembers;
